export default __webpack_public_path__ + "static/media/fl-icon-50-pink.96d79772.svg";